module.exports = __webpack_public_path__ + "static/media/23_negro.79378ffc.svg";